import { TextFieldInput } from "@smart/itops-sb-design-system-dom";

import { FieldGroup } from "./field-group";
import { Label } from "./label";
import { FieldProps, FieldWrapper } from "./wrapper";
import { fieldName } from "../../hooks";

export const TextField = ({
  field,
  index,
  innerRef,
  value,
  error,
  loading,
  disabled,
  onChange,
  onBlur,
}: FieldProps<HTMLInputElement>) => {
  const id = fieldName({ field, index });
  const errorId = fieldName({ field, index, suffix: "error" });

  return (
    <FieldWrapper disabled={disabled} isLoading={loading}>
      <FieldGroup
        id={id}
        hint={field.hint ?? undefined}
        label={<Label {...field} />}
      >
        <TextFieldInput
          ref={innerRef}
          id={id}
          name={id}
          data-testid={id}
          error={!!error}
          message={error ?? undefined}
          aria-invalid={!!error}
          aria-errormessage={errorId ?? undefined}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
        />
      </FieldGroup>
    </FieldWrapper>
  );
};
